// NOTICE: KAPTION-INTEGRATION
// rumo-carousels.PROTOCOL.2 — a cards message is a Rumo carousel when the server
// stamped a layout on it (it only does so for v1 carousels on Embedded inboxes).
// Shared by the web widget (snake_case payloads) and the dashboard (camelCase).
export const CAROUSEL_LAYOUTS = ['compact', 'tall', 'list'];
export const LIST_VISIBLE_ROWS = 6;

export const carouselLayoutOf = (contentType, contentAttributes) => {
  if (contentType !== 'cards') return null;
  const layout = contentAttributes?.layout;
  return CAROUSEL_LAYOUTS.includes(layout) ? layout : null;
};

const pick = (object, snake, camel) => object?.[snake] ?? object?.[camel];

const isHttps = url => typeof url === 'string' && /^https:\/\//i.test(url);

// Cards as plain objects with one naming, dropping anything without a title.
export const carouselCards = (contentAttributes = {}) => {
  const items = Array.isArray(contentAttributes?.items)
    ? contentAttributes.items
    : [];
  return items
    .filter(item => item && typeof item.title === 'string' && item.title)
    .map((item, index) => ({
      key: pick(item, 'kaption_id', 'kaptionId') || `card-${index}`,
      title: item.title,
      description: item.description || '',
      mediaUrl: isHttps(pick(item, 'media_url', 'mediaUrl'))
        ? pick(item, 'media_url', 'mediaUrl')
        : null,
      badge: pick(item, 'kaption_badge', 'kaptionBadge') || '',
      actions: (Array.isArray(item.actions) ? item.actions : []).filter(
        action =>
          action &&
          ['navigate', 'link'].includes(action.type) &&
          typeof action.text === 'string' &&
          action.text
      ),
    }));
};
